/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { throttle } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@material-ui/core';
import ProductConfigurableGroup from '../../components/ProductConfigurableGroup';
const { selectProductBaseURL } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
import ProductOptionGroup from '../../components/ProductOptionGroup';
import ProductAddToCart from '../../components/ProductAddToCart/index.jsx';
import CustomizedBox from '../../components/ProductTile/CustomizedBox';
const { selectProductEntities } = Slices.productSlice;
import { generateCustomization, getDefaultDependent } from 'spwa-ui-library/esm/utils/helper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';
const cardWrapClass = '.card-wrap';
function ProductCustomize({
  // executeScroll,
  // refArray,
  imgBaseUrl,
  selectedProduct,
  setSelectedSize,
  // setRefArray,
  addCart,
  // customizeItem,
  // customizeIndex,
  isDesktop,
  productID,
  categoryID,
  resetButton,
  menuItem,
  // currentItem,
  SetResetDependent,
  resetDependent,
}) {
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const productRoute = '';
  const intl = useIntl();
  const productImgBaseUrl = useSelector(selectProductBaseURL);
  const productsMap = useSelector(selectProductEntities);
  const tempItems = useSelector((state) => state.tempCart);
  const [removeCust, setRemoveCust] = React.useState(false);
  const [customToShow, setCustomToShow] = React.useState(selectedProduct || {});
  const [customVal, setCustomVal] = React.useState('');
  const [lists, setListArr] = useState([]);
  const [tabLists, seTabsListArr] = useState([]);
  const [handleClick, setHandleClick] = useState(false);
  const [tabValue, setTabVal] = useState(0);
  const findInVal = tempItems.data?.items?.findIndex(({ id }) => id === +selectedProduct.id);
  let priceVal =
    tempItems.data?.items[findInVal]?.tempPrice || tempItems.data?.items[findInVal]?.finalPrice;
  // if (currentItem.qty > 1) {
  //   priceVal = priceVal / currentItem.qty;
  // }
  //   React.useState(
  //   tempItems.data.items[customizeIndex]
  //     ? tempItems.data.items[customizeIndex].tempPrice
  //     : tempItems.data.cartValue
  // );
  const checkReset = () => {
    setRemoveCust(true);
    resetButton();
    const defaultCondiment = getDefaultDependent(selectedProduct?.steps);
    setCheckDependent(defaultCondiment);
  };

  useEffect(() => {
    if (resetDependent) {
      const defaultCondiment = getDefaultDependent(selectedProduct?.steps);
      setCheckDependent(defaultCondiment);
      SetResetDependent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetDependent]);

  useEffect(() => {
    if (resetDependent) {
      const defaultCondiment = getDefaultDependent(selectedProduct.bundleProductOptions);
      setCheckDependent(defaultCondiment);
      SetResetDependent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (resetDependent) {
      const defaultCondiment = getDefaultDependent(selectedProduct.bundleProductOptions);
      setCheckDependent(defaultCondiment);
      SetResetDependent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCustomize = () => {
    const inCusto = tempItems?.customize?.items?.findIndex(({ id }) => id === +productID);
    let other = [];
    menuItem.items.length &&
      menuItem.items.forEach((inner) => {
        other.push(productsMap[inner]);
      });
    const ItemCustomize = { ...menuItem, items: other };
    const getCustomizeVal = generateCustomization(
      tempItems?.customize?.items[inCusto],
      ItemCustomize
    );
    return (
      <CustomizedBox
        route={productRoute}
        customizeDescription={getCustomizeVal}
        productObj={customToShow}
        reset={true}
        resetButton={checkReset}
      />
    );
  };

  const [checkDependent, setCheckDependent] = React.useState([]);
  const getMidValue = (ele) => {
    let eleRect;
    if (ele) {
      eleRect = ele.getBoundingClientRect();
    }
    const v = eleRect?.height + eleRect?.bottom;
    return { sum: v, mid: v / 2, id: ele.id, height: eleRect.height };
  };
  const getSumHeightsOfCards = (items) => {
    let sumAll = 0;
    if (items && items.length) {
      items.forEach((tt) => {
        sumAll += tt.height;
      });
    }
    return sumAll;
  };
  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }
  function scrollTo(element, to, duration) {
    let start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 10;
    let animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }
  const handleScroll = throttle(() => {
    const newFilter =
      tabLists &&
      tabLists.length > 0 &&
      tabLists.filter(({ position, ingredient, isDependent }) => {
        if (isDependent && !checkDependent?.includes(position) && ingredient === 0) {
          return false;
        }
        return true;
      });
    if (handleClick) {
      return false;
    }
    let ele = document.querySelector(cardWrapClass);
    // ON SCROLL FIRED
    const values = [];
    lists &&
      lists.length > 0 &&
      lists.forEach((text) => {
        const target = document.getElementById(text);
        if (target) {
          values.push(getMidValue(target));
        }
      });
    //SUM OF ALL THE ITEMS
    let sumAll = getSumHeightsOfCards(values);
    // SET CURRENT ACTIVE ID
    const headDiff = ele.scrollHeight + 150 - sumAll;
    let id = '';
    let findIndex;
    tabLists &&
      tabLists.length > 0 &&
      tabLists.forEach(({ position, isDependent, ingredient, id: itemId }) => {
        if (isDependent && !checkDependent?.includes(position) && ingredient === 0) {
          return (findIndex = itemId);
        }
      });
    if (ele.scrollTop >= ele.scrollHeight - 60 - ele.offsetParent.scrollHeight) {
      id = values[values.length - 1]?.id;
      let index = tabLists && tabLists.length > 0 && tabLists.findIndex((item) => item.id === id);
      if (!handleClick) {
        const item = newFilter[findIndex ? index - 1 : index];
        localStorage.setItem('activeIndex', `${item.title}-${item.position}`);
        setTabVal(findIndex ? index - 1 : index);
      }
    } else if (values) {
      for (let i = 0; i < values.length - 2; i++) {
        if (
          (values[i].sum > ele.scrollTop + headDiff && values[i + 1].sum) <
          ele.scrollTop + headDiff
        ) {
          id =
            (values[i].sum + values[i + 1].sum) / 2 - (headDiff + 180) > ele.scrollTop + headDiff
              ? values[i].id
              : values[i + 1].id;
        }
      }
      let filteredList = tabLists;
      if (findIndex) {
        filteredList =
          tabLists &&
          tabLists.length > 0 &&
          tabLists.filter((item) => item.id.trim() !== findIndex.trim());
      }
      let itemIndex =
        filteredList && filteredList.length > 0 && filteredList.findIndex((item) => item.id === id);
      if (!handleClick) {
        if (itemIndex > -1) {
          const item = newFilter[itemIndex];
          localStorage.setItem('activeIndex', `${item.title}-${item.position}`);
          setTabVal(itemIndex ? itemIndex : '');
        } else {
          setTabVal(0);
        }
      }
    }
  }, 200);
  useEffect(() => {
    const { variants, steps } = menuItem;
    const { options } = variants;
    let arr = [];
    let tabs = [];
    if (options && options?.length > 0) {
      options.forEach((item) => {
        const { title, position } = item;
        let value = `${title.split(' ').join('')}-${position}`;
        arr.push(value);
        tabs.push({ title, id: value, position });
      });
    }
    if (steps && steps?.length > 0) {
      steps.forEach((item) => {
        const { subtitle, compId, isDependent, position, ingredient } = item;
        let value = `${subtitle.split(' ').join('')}-${compId}`;
        arr.push(value);
        tabs.push({ title: subtitle, id: value, isDependent, position, ingredient });
      });
    }
    if (arr && arr.length > 0) {
      setListArr(arr);
    }
    if (tabs && tabs.length > 0) {
      seTabsListArr(tabs);
    }
  }, [menuItem]);
  useEffect(() => {
    let ele = document.querySelector(cardWrapClass);
    let interval;
    if (ele && !!lists.length) {
      let isScroll = handleClick ? '' : 'scroll';
      interval = setTimeout(() => {
        ele.addEventListener(isScroll, handleScroll, { passive: true });
      }, 1000);
    }
    return () => {
      ele.removeEventListener('scroll', handleScroll, { passive: true });
      clearInterval(interval);
    };
  }, [handleClick, handleScroll, lists]);
  useEffect(() => {
    return () => {
      localStorage.removeItem('activeIndex');
    };
  }, []);
  function LinkTab(props) {
    if (tabValue === 0 && props.value === 0) {
      localStorage.setItem('activeIndex', `${props.uniqueid}`);
    }
    return (
      <Tab
        component="a"
        textColor={parseInt(props.key) === parseInt(tabValue) ? 'var(--clr-primary-400)' : ''}
        onClick={(event) => {
          event.preventDefault();
          localStorage.setItem('activeIndex', props.uniqueid);
        }}
        {...props}
      />
    );
  }
  let renderTabs =
    tabLists &&
    tabLists.length > 0 &&
    tabLists.map(({ title, id, position, isDependent, ingredient }, key) => {
      let renderTab = '';
      if ( (isDependent && !checkDependent?.includes(position)) && ingredient == 0) {
        renderTab = '';
      } else {
        renderTab = (
          <LinkTab uniqueid={`${title}-${position}`} label={title} href={`#${id}`} key={key} />
        );
      }
      return renderTab;
    });

  function convert(str) {
    return decodeURIComponent(JSON.parse('"' + str.replace(/"/g, '\\"') + '"'));
  }
  //eslint:fix / is removed
  const handleTabChange = (e, value) => {
    setHandleClick((prev) => !prev);
    let ele = document.querySelector(cardWrapClass);
    const url =
      intl.locale === 'ar'
        ? convert(e.currentTarget.href.split('#')[1])
        : e.currentTarget.href.split('#')[1];
    const target = document.getElementById(url);
    if (target) {
      let diffToBeSubtracted = value === 0 ? 125 : 100;
      let topPos = target.offsetTop - diffToBeSubtracted;
      let targetTop = target.offsetTop;
      // FOR MOBILE
      if (!isDesktop) {
        window.scrollTo({
          top:
            value === 0
              ? targetTop - diffToBeSubtracted - 150
              : targetTop - diffToBeSubtracted - 140,
          behavior: 'smooth',
        });
        localStorage.removeItem('activeIndex');
      }
      let topDiff = topPos - ele.scrollTop;
      // SET SCROLL TOP VALUE FOR TARGET
      if (target) {
        setTabVal(value);
        let topScroll = topPos;
        if (topDiff > 0 && topDiff / 2 < 140 && ele.scrollTop > 200) {
          topScroll -= 160;
        }
        if (topDiff > 0 && topDiff / 2 < 100 && ele.scrollTop > 200) {
          topScroll -= 80;
        }
        scrollTo(ele, topScroll, 600);
      }
      let time = isDesktop ? 1500 : 3000;
      setTimeout(() => {
        setHandleClick((prev) => !prev);
      }, time);
    }
  };
  const handleMobileScroll = throttle(() => {
    if (handleClick) {
      return false;
    }
    const newFilter =
      tabLists &&
      tabLists.length > 0 &&
      tabLists.filter(({ position, ingredient, isDependent }) => {
        // eslint-disable-next-line eqeqeq
        if (isDependent && !checkDependent?.includes(position) && ingredient == 0) {
          return false;
        }
        return true;
      });
    if (!handleClick) {
      let ele = document.querySelector(cardWrapClass);
      // ON SCROLL FIRED
      let middleElement, viewportHeight;
      let topPos;
      lists.forEach(function (m) {
        const target = document.getElementById(m);
        if (target) {
          let pos = target.getBoundingClientRect().top + 240;
          viewportHeight = ele.clientHeight;
          if (pos > viewportHeight / 5.5 && pos < viewportHeight / 5.5) {
            middleElement = target?.id;
            topPos = target.offsetTop;
            return false; // stop iteration
          }
          if (Math.round(pos / 3 - 100) < 100) {
            middleElement = target?.id;
            topPos = target.offsetTop;
            return false; // stop iteration
          }
        }
      });
      let itemIndex;
      if (middleElement) {
        itemIndex =
          newFilter &&
          newFilter.length > 0 &&
          newFilter.findIndex((item) => item.id === middleElement);
      }
      if (itemIndex > -1) {
        setTabVal(itemIndex ? itemIndex : 0);
        scrollTo(ele, topPos, 600);
      }
      // FOR DEFAULT SELECT FOR FIRST ITEM
      if (topPos < 300) {
        setTabVal(0);
        scrollTo(ele, 60, 600);
      }
    }
  }, 500);
  useEffect(() => {
    let interval;
    if (lists.length) {
      let isScroll = handleClick ? '' : 'scroll';
      setTimeout(() => {
        interval = window.addEventListener(isScroll, handleMobileScroll, { passive: true });
      }, 800);
    }
    return () => {
      window.removeEventListener('scroll', handleMobileScroll, { passive: true });
      clearInterval(interval);
    };
  }, [handleClick, handleMobileScroll, lists.length]);

  useEffect(() => {
    const defaultCondiment = getDefaultDependent(selectedProduct.steps);
    setCheckDependent(defaultCondiment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getCustom = tempItems.customize?.items?.findIndex(({ id }) => id === +productID);
  useEffect(() => {
    if (getCustom !== -1) {
      const setVal = tempItems.customize?.items[getCustom];
      const customizeDescription = generateCustomization(setVal);
      const newPr = { ...setVal };
      setCustomToShow(newPr);
      setCustomVal(customizeDescription);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCustom]);

  const { assets = [] } = selectedProduct;

  // TODO: NEED TO UPDATE BELOW CODE AS PER REQUIREMENT IN ADP
  // useEffect(() => {
  //   let dependents = new Set();

  //   // all the checks are to be made in bundleProductOptions
  //   if (findInVal !== -1) {
  //     tempItems.data.items[findInVal].bundleProductOptions.forEach((productOption) => {
  //       // check for addon
  //       if (
  //         productOption.isDependent == 1 &&
  //         productOption.isAddon == 1 &&
  //         productOption?.productLinks.filter((productLink) => productLink.selected == 1).length > 0
  //       ) {
  //         dependents.add(productOption.position);
  //       }

  //       // check for dependent
  //       // eslint-disable-next-line no-unused-expressions
  //       productOption?.productLinks.forEach((productLink) => {
  //         if (productLink.selected == 1) {
  //           // eslint-disable-next-line no-unused-expressions
  //           productLink?.dependentSteps.forEach((dependentStep) => dependents.add(dependentStep));
  //         }
  //       });
  //     });

  //     setCheckDependent(Array.from(dependents));
  //   }
  // }, [findInVal, tempItems.data.items]);

  // useEffect(() => {
  //   let dependents = new Set();
  //   if (findInVal !== -1) {
  //     // all the checks are to be made in bundleProductOptions
  //     tempItems.data.items[findInVal].bundleProductOptions.forEach((productOption) => {
  //       // check for addon
  //       if (
  //         productOption.isDependent == 1 &&
  //         productOption.isAddon == 1 &&
  //         productOption?.productLinks.filter((productLink) => productLink.selected == 1).length > 0
  //       ) {
  //         dependents.add(productOption.position);
  //       }
  //       // check for dependent
  //       // eslint-disable-next-line no-unused-expressions
  //       productOption?.productLinks.forEach((productLink) => {
  //         if (productLink.selected == 1) {
  //           // eslint-disable-next-line no-unused-expressions
  //           productLink?.dependentSteps.forEach((dependentStep) => dependents.add(dependentStep));
  //         }
  //       });
  //     });
  //     setCheckDependent(Array.from(dependents));
  //   }
  // }, [findInVal, tempItems.data.items]);

  return (
    <>
      <div className={`${css.productImage}`}>
        <img
          src={`${assets[0]?.src}`}
          alt={menuItem.name}
          width="235"
          height="235"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImg;
            e.target.width = 150;
            e.target.height = 150;
            e.target.className = css.noImgFound;
          }}
        />
        {isDesktop && (
          <div className={css.productDetail}>
            <div className={css.heading}>
              <h3>{menuItem.name}</h3>
              <p className={css.horizontalWidget}></p>
            </div>
            {(customToShow.customized === 1 || customToShow.customized === true) && !removeCust ? (
              getCustomize()
            ) : (
              <div className={css.productDesc}>
                <Button
                  variant="outlined"
                  size="small"
                  className={css.resetBtn}
                  onClick={resetButton}
                >
                  {intl.formatMessage({ id: 'customize_reset' })}
                </Button>
                <div className={css.onlyDescription}>{selectedProduct.description}</div>
              </div>
            )}
            {/* <div className={css.productDesc}>{selectedProduct.description}</div> */}

            <div className={css.buttonDesktop}>
              <ProductAddToCart
                isDesktop={true}
                buttonText={
                  <FormattedMessage id="customize_updateitem" defaultMessage="Add to cart" />
                }
                onClick={addCart}
                price={priceVal}
                // price={
                //   customizeItem.data.items[customizeIndex]
                //     ? customizeItem.data.items[customizeIndex].tempPrice
                //     : customizeItem.data.cartValue
                // }
                selectedProduct={selectedProduct}
                categoryID={categoryID}
              />
            </div>
          </div>
        )}
      </div>
      <div className={`${css.groupTitle}`}>
        <Tabs
          className={css.groupTabs}
          scrollButtons={'off'}
          variant={'scrollable'}
          orientation={isDesktop ? 'vertical' : 'horizontal'}
          value={tabValue}
          onChange={handleTabChange}
        >
          {renderTabs}
        </Tabs>
      </div>
      <div className={`${css.contentContainer} card-wrap`}>
        {selectedProduct.configurableProductOptions &&
          selectedProduct.configurableProductOptions.map((configGroup, ids) => {
            const keyVal = `ProductconfigurableGroup-${configGroup.position}`;
            const title = menuItem.configurableProductOptions[ids].title;
            const uniqueName = `${configGroup.title}-${configGroup.position}`;
            return (
              <ProductConfigurableGroup
                resetDependent={resetDependent}
                title={title}
                selectedSize={setSelectedSize}
                configGroup={configGroup}
                key={keyVal}
                id={keyVal}
                productID={productID}
                imagePath={`${country}${selectedProduct.imageThumbnail}`}
                configItem={selectedProduct.items}
                isDesktop={isDesktop}
                uniqueName={uniqueName}
              />
            );
          })}

        {selectedProduct.typeId === 'bundle' &&
          selectedProduct.steps.map((optionGroup, idx) => {
            const key = `ProductOptionGroup-${optionGroup.position}-${optionGroup.type}`;
            const subMenu = menuItem.steps[idx];
            if (
              (optionGroup.isDependent &&
              !checkDependent.includes(optionGroup.position)) &&
              optionGroup.ingredient == 0
            ) {
              return '';
            }
            const uniqueName = `${optionGroup.name}-${optionGroup.position}`;
            return (
              <ProductOptionGroup
                uniqueName={uniqueName}
                checkDependent={checkDependent}
                setCheckDependent={setCheckDependent}
                subMenu={subMenu}
                mainItem={selectedProduct.id}
                optionGroup={optionGroup}
                key={key}
                id={key}
                tabValue={tabValue}
                isDesktop={isDesktop}
                country={country}
                selectedProduct={selectedProduct}
              />
            );
          })}
        {!isDesktop && (
          <div className={css.ctaBar}>
            <div className={css.priceContainer}>
              <ProductAddToCart
                imgSrc={`${imgBaseUrl.product}/${country}/${selectedProduct.imageThumbnail}`}
                isDesktop={false}
                buttonText={
                  <FormattedMessage id="customize_updateitem" defaultMessage="Add to cart" />
                }
                onClick={addCart}
                // price={priceVal}
                price={priceVal}
                selectedProduct={selectedProduct}
                categoryID={categoryID}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ProductCustomize;
